import Indicator from '../Indicator';
import BandMarker from '../markers/BandMarker';
import LineMarker from '../markers/LineMarker';

/** Price Channel indicator */
export default class CommodityChannelIndexIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {Object} - Default parameters object
	 * @property {String} id - Indicator ID
	 * @property {String} name - Indicator name
	 * @property {String} description - Indicator description
	 * @property {Object[]} inputs - Indicator inputs
	 * @property {Object[]} bands - Bands to display
	 */
	_getDefaultParams() {
		return {
			id: 'commoditychannelindex',
			name: 'Commodity Channel Index',
			description:
				'Commodity Channel Index is a momentum indicator that compares current prices to the average typical price. Above 100 is considered overbought, where upwards momentum is strong but unsustainable. Similarly, below -100 is considered oversold, where downwards momentum is also strong but unsustainable.',
			inputs: [{ name: 'period', value: 20 }],
			bands: [
				{
					labelTranslationKey: 'band.overbought',
					valHigh: 10000, // The indicator should never have values this high
					valLow: 100
				},
				{
					labelTranslationKey: 'band.oversold',
					valHigh: -100,
					valLow: -10000 // sufficiently negative number
				}
			],
			componentSeries: [
				{ id: 'commoditychannelindex' }
			]
		};
	}

	/**
	 * @returns {Object}
	 * @property {LineMarker} line
	 * @property {BandMarker} overbought
	 * @property {BandMarker} zero
	 * @property {BandMarker} oversold
	 */
	_getMarkers() {
		return {
			line: new LineMarker(),
			overbought: new BandMarker(this.params.bands[0], this.panel),
			oversold: new BandMarker(this.params.bands[1], this.panel)
		};
	}

	/** @param {Object} data - Symbol data object */
	render(data, sessionType) {
		this.markers.overbought.render(this.panel, this.params.style.overbought, true);
		this.markers.oversold.render(this.panel, this.params.style.oversold, false);
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
